import { DateTimeFormatTypes } from '@/models/common/date-time-format-types.model';
import { DateTimeRangeTypes } from '@/models/common/date-time-range-types.model';
import { DateTimeUnit } from '@/models/common/date-time-unit.model';

export const getDateTimeRange = (rangeType: DateTimeRangeTypes): [Date, Date] => {
  const now = dayjs();
  const ranges: Record<DateTimeRangeTypes, () => [Date, Date]> = {
    [DateTimeRangeTypes.LIFETIME]: () => [
      now.subtract(10, DateTimeUnit.YEAR).startOf(DateTimeUnit.YEAR).toDate(),
      now.toDate(),
    ],
    [DateTimeRangeTypes.TODAY]: () => [
      now.startOf(DateTimeUnit.DAY).toDate(),
      now.toDate(),
    ],
    [DateTimeRangeTypes.YESTERDAY]: () => [
      now.subtract(1, DateTimeUnit.DAY).startOf(DateTimeUnit.DAY).toDate(),
      now.subtract(1, DateTimeUnit.DAY).endOf(DateTimeUnit.DAY).toDate(),
    ],
    [DateTimeRangeTypes.THIS_MONTH]: () => [
      now.startOf(DateTimeUnit.MONTH).toDate(),
      now.toDate(),
    ],
    [DateTimeRangeTypes.LAST_MONTH]: () => [
      now.subtract(1, DateTimeUnit.MONTH).startOf(DateTimeUnit.MONTH).toDate(),
      now.subtract(1, DateTimeUnit.MONTH).endOf(DateTimeUnit.MONTH).toDate(),
    ],
    [DateTimeRangeTypes.CUSTOM]: () => [
      now.startOf(DateTimeUnit.DAY).toDate(),
      now.toDate(),
    ],
    [DateTimeRangeTypes.LAST_SEVEN_DAYS]: () => [
      now.subtract(7, DateTimeUnit.DAY).startOf(DateTimeUnit.DAY).toDate(),
      now.toDate(),
    ],
  };

  return ranges[rangeType]();
};

export const getDateTimeRangeFormatted = (
  rangeType: DateTimeRangeTypes,
  formatType: DateTimeFormatTypes,
): [string, string] => {
  const [start, end] = getDateTimeRange(rangeType);

  return [
    dayjs(start).format(formatType),
    dayjs(end).format(formatType),
  ];
};
